import { render, staticRenderFns } from "./QuoteMessage.vue?vue&type=template&id=18213312&scoped=true"
import script from "./QuoteMessage.vue?vue&type=script&lang=js"
export * from "./QuoteMessage.vue?vue&type=script&lang=js"
import style0 from "./QuoteMessage.vue?vue&type=style&index=0&id=18213312&prod&scoped=true&lang=scss"
import style1 from "./QuoteMessage.vue?vue&type=style&index=1&id=18213312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18213312",
  null
  
)

export default component.exports